export default __webpack_public_path__ + "static/media/NotFoundImg.91047365.svg";